import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-login-links.component.scss';
var BannerLoginLinks = /** @class */ (function (_super) {
    tslib_1.__extends(BannerLoginLinks, _super);
    function BannerLoginLinks(element) {
        return _super.call(this, element) || this;
    }
    BannerLoginLinks.prototype.init = function () {
        this.containerCurrent = this.element;
        if (document.querySelector('.banner-hero-image-full-no-carousel')) {
            this.containerBannerHeroImageFullNoCarousel = Array.from(document.querySelectorAll('.banner-hero-image-full-no-carousel'));
            this.updateBannerHeroImageFullNoCarousel();
        }
        if (document.querySelector('.hero-banner')) {
            this.containerBannerHero = Array.from(document.querySelectorAll('.hero-banner'));
            this.updateBannerHero();
        }
        if (document.querySelector('.banner-hero-image-full')) {
            this.containerBannerHeroImageFull = Array.from(document.querySelectorAll('.banner-hero-image-full'));
            this.updateBannerHeroImageFull();
        }
    };
    BannerLoginLinks.prototype.bindEvents = function () {
    };
    BannerLoginLinks.prototype.updateBannerHeroImageFullNoCarousel = function () {
        var _this = this;
        this.containerBannerHeroImageFullNoCarousel.map(function (container) {
            if (container.querySelector('.banner-hero-image-full-no-carousel__banner--container')) {
                var bannerContentContainer = container.querySelector('.banner-hero-image-full-no-carousel__banner--container');
                var createBannerContainer = document.createElement('div');
                createBannerContainer.classList.add('banner-login-links__bannerheroimagefullnocarousel');
                var createBootstrapContainer = document.createElement('div');
                createBootstrapContainer.classList.add('container');
                var createBootstrapContainerRow = document.createElement('div');
                createBootstrapContainerRow.classList.add('row');
                var createBootstrapContainerColumn5 = document.createElement('div');
                createBootstrapContainerColumn5.classList.add('col-md-5');
                var createBootstrapContainerColumn7 = document.createElement('div');
                createBootstrapContainerColumn7.classList.add('col-md-7');
                createBootstrapContainerColumn7.classList.add('text-right');
                createBootstrapContainerColumn7.innerHTML = _this.containerCurrent.innerHTML;
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn5);
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn7);
                createBootstrapContainer.appendChild(createBootstrapContainerRow);
                createBannerContainer.appendChild(createBootstrapContainer);
                bannerContentContainer.appendChild(createBannerContainer);
                // onload
                if (document.body.clientWidth > 767) {
                    _this.containerCurrent.classList.remove('banner-login-links__mobile');
                    _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefullnocarousel');
                }
                else {
                    _this.containerCurrent.classList.add('banner-login-links__mobile');
                    _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefullnocarousel');
                }
                // resize
                window.addEventListener('resize', function (event) {
                    if (document.body.clientWidth > 767) {
                        _this.containerCurrent.classList.remove('banner-login-links__mobile');
                        _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefullnocarousel');
                    }
                    else {
                        _this.containerCurrent.classList.add('banner-login-links__mobile');
                        _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefullnocarousel');
                    }
                });
            }
        });
    };
    BannerLoginLinks.prototype.updateBannerHeroImageFullNoCarouselOLD = function () {
        var _this = this;
        this.containerBannerHeroImageFullNoCarousel.map(function (container) {
            if (container.querySelector('.banner-hero-image-full-no-carousel__banner--container')) {
                var bannerContentContainer = container.querySelector('.banner-hero-image-full-no-carousel__banner--container');
                if (bannerContentContainer.querySelector('.row')) {
                    // vars
                    var bannerContentContainerRow = bannerContentContainer.querySelector('.row');
                    var createExtraColumn = document.createElement('div');
                    createExtraColumn.classList.add('col-md-7');
                    createExtraColumn.classList.add('text-right');
                    createExtraColumn.innerHTML = _this.containerCurrent.innerHTML;
                    bannerContentContainerRow.appendChild(createExtraColumn);
                    // onload
                    if (document.body.clientWidth > 767) {
                        _this.containerCurrent.classList.remove('banner-login-links__mobile');
                        _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefullnocarousel');
                    }
                    else {
                        _this.containerCurrent.classList.add('banner-login-links__mobile');
                        _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefullnocarousel');
                    }
                    // resize
                    window.addEventListener('resize', function (event) {
                        if (document.body.clientWidth > 767) {
                            _this.containerCurrent.classList.remove('banner-login-links__mobile');
                            _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefullnocarousel');
                        }
                        else {
                            _this.containerCurrent.classList.add('banner-login-links__mobile');
                            _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefullnocarousel');
                        }
                    });
                }
            }
        });
    };
    BannerLoginLinks.prototype.updateBannerHero = function () {
        var _this = this;
        this.containerBannerHero.map(function (container) {
            if (container.querySelector('.hero-banner__slider-container')) {
                var bannerContentContainer = container.querySelector('.hero-banner__slider-container');
                var createAbsoluteContainer = document.createElement('div');
                createAbsoluteContainer.classList.add('banner-login-links__bannerheroblue');
                var createBootstrapContainer = document.createElement('div');
                createBootstrapContainer.classList.add('container');
                var createBootstrapContainerRow = document.createElement('div');
                createBootstrapContainerRow.classList.add('row');
                var createBootstrapContainerColumn5 = document.createElement('div');
                createBootstrapContainerColumn5.classList.add('col-md-5');
                var createBootstrapContainerColumn7 = document.createElement('div');
                createBootstrapContainerColumn7.classList.add('col-md-7');
                createBootstrapContainerColumn7.classList.add('text-right');
                createBootstrapContainerColumn7.innerHTML = _this.containerCurrent.innerHTML;
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn5);
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn7);
                createBootstrapContainer.appendChild(createBootstrapContainerRow);
                createAbsoluteContainer.appendChild(createBootstrapContainer);
                bannerContentContainer.appendChild(createAbsoluteContainer);
                // onload
                if (document.body.clientWidth > 767) {
                    _this.containerCurrent.classList.remove('banner-login-links__mobile');
                    _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroblue');
                }
                else {
                    _this.containerCurrent.classList.add('banner-login-links__mobile');
                    _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroblue');
                }
                // resize
                window.addEventListener('resize', function (event) {
                    if (document.body.clientWidth > 767) {
                        _this.containerCurrent.classList.remove('banner-login-links__mobile');
                        _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroblue');
                    }
                    else {
                        _this.containerCurrent.classList.add('banner-login-links__mobile');
                        _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroblue');
                    }
                });
            }
        });
    };
    BannerLoginLinks.prototype.updateBannerHeroImageFull = function () {
        var _this = this;
        var index = 0;
        this.containerBannerHeroImageFull.map(function (container) {
            if (index === 0) {
                var createBannerContainer = document.createElement('div');
                createBannerContainer.classList.add('banner-login-links__bannerheroimagefull');
                var createBootstrapContainer = document.createElement('div');
                createBootstrapContainer.classList.add('container');
                var createBootstrapContainerRow = document.createElement('div');
                createBootstrapContainerRow.classList.add('row');
                var createBootstrapContainerColumn5 = document.createElement('div');
                createBootstrapContainerColumn5.classList.add('col-md-5');
                var createBootstrapContainerColumn7 = document.createElement('div');
                createBootstrapContainerColumn7.classList.add('col-md-7');
                createBootstrapContainerColumn7.classList.add('text-right');
                createBootstrapContainerColumn7.innerHTML = _this.containerCurrent.innerHTML;
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn5);
                createBootstrapContainerRow.appendChild(createBootstrapContainerColumn7);
                createBootstrapContainer.appendChild(createBootstrapContainerRow);
                createBannerContainer.appendChild(createBootstrapContainer);
                container.appendChild(createBannerContainer);
                // onload
                if (document.body.clientWidth > 767) {
                    _this.containerCurrent.classList.remove('banner-login-links__mobile');
                    _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefull');
                }
                else {
                    _this.containerCurrent.classList.add('banner-login-links__mobile');
                    _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefull');
                }
                // resize
                window.addEventListener('resize', function (event) {
                    if (document.body.clientWidth > 767) {
                        _this.containerCurrent.classList.remove('banner-login-links__mobile');
                        _this.containerCurrent.classList.remove('banner-login-links__mobile--bannerheroimagefull');
                    }
                    else {
                        _this.containerCurrent.classList.add('banner-login-links__mobile');
                        _this.containerCurrent.classList.add('banner-login-links__mobile--bannerheroimagefull');
                    }
                });
            }
            index++;
        });
    };
    return BannerLoginLinks;
}(Base));
export { BannerLoginLinks };



//////////////////
// WEBPACK FOOTER
// ./components/banner-login-links/banner-login-links.component.ts
// module id = 699
// module chunks = 0